import { useMutation } from "react-query";
import { updateMasterLegalEntity } from "../../../../../actions/Utilities/MasterLegalEntity";
import { toast } from "../../../../../components/toastNotification";
import {
  masterLegalEntityFetching,
  editStateMasterLegalEntity,
} from "../atoms/atoms";
import { useRecoilState, useSetRecoilState } from "recoil";
import { IMasterLegalEntity } from "../type/MasterLegalEntityTypeInterface";

const useUpdateMasterLegalEntity = () => {
  const setActionAddState = useSetRecoilState(editStateMasterLegalEntity);
  const [isReFetching, setIsReFetching] = useRecoilState(
    masterLegalEntityFetching
  );
  const { mutate } = useMutation(
    (Data: IMasterLegalEntity) => updateMasterLegalEntity(Data),
    {
      onSuccess: (res) => {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              " Master Legal Entity Updated Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              ` Master Legal Entity Updated Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Updating Master Legal Entity failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Updating Master Legal Entity failed ",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire(
              "Updating  Master Legal Entity failed ",
              `Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire(
              "Updating  Master Legal Entity failed",
              `${res.Message}`,
              "error"
            );
        }
        // Redirect to View
        setActionAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire(
          "Update  Master Legal Entity failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );
  return mutate;
};
export default useUpdateMasterLegalEntity;
